/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Ccsl_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_complete_toast = /** @type {((inputs?: Ccsl_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт завершен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação concluída")
	return /** @type {LocalizedString} */ ("Export Complete")
});